//IConfigSetting

import { IConfigSetting } from '../interfaces/models';
import { ID } from '@datorama/akita';

export class ConfigSetting implements IConfigSetting {
  name: string;
  value: string;
  type: string;
  createdBy: string;
  createdAt: Date;
  modifiedBy: string;
  modifiedAt: Date;
  id: ID;

  constructor(
    config: IConfigSetting = {
      id: '',
      name: '',
      value: '',
      type: '',
      createdBy: '',
      createdAt: new Date(),
      modifiedBy: '',
      modifiedAt: new Date(),
    }
  ) {
    const {
      id,
      name,
      value,
      type,
      createdBy,
      createdAt,
      modifiedBy,
      modifiedAt,
    } = config;

    this.id = id;
    this.name = name;
    this.value = value;
    this.type = type;
    this.createdBy = createdBy;
    this.createdAt = createdAt;
    this.modifiedAt = modifiedAt;
    this.modifiedBy = modifiedBy;
  }
}
